import { render } from "./SideMenuBar.vue?vue&type=template&id=2896df55"
import script from "./SideMenuBar.vue?vue&type=script&lang=js"
export * from "./SideMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__